import { Link } from "react-router-dom";
import { CONTACT, whatsappLink } from "../../config";
import { track } from "../../lib/api";

export const Footer = ({ onBook }) => (
  <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-[var(--surface)]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <div>
          <img src="/logo-wordmark.png" alt="Juan Pablo Cortés" className="h-9 w-auto" />
          <p className="mt-4 text-zinc-400 max-w-sm">
            Estudio de desarrollo web y software a la medida. Resultado, velocidad y criterio.
          </p>
        </div>
        <div className="md:justify-self-end">
          <button
            onClick={onBook}
            data-testid="footer-book-btn"
            className="rounded-full bg-[var(--magenta)] text-white font-semibold px-7 py-4 hover-lift hover:magenta-glow"
          >
            Agendar llamada
          </button>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-500">
        <p>© {new Date().getFullYear()} Juan Pablo Cortés. Todos los derechos reservados.</p>
        <div className="flex items-center gap-6">
          <Link
            to="/aviso-de-privacidad"
            data-testid="footer-privacy"
            className="hover:text-white transition-colors duration-200"
          >
            Aviso de privacidad
          </Link>
          <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors duration-200">Email</a>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", null, { location: "footer" })}
            className="hover:text-white transition-colors duration-200"
          >
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  </footer>
);
